import { useEffect } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import ReportGroupsSidebar from '@/components/ReportGroupsSidebar';
import { ReportListView } from '@/components/ReportListView';
import { ReportFooter } from '@/components/ReportFooter';
import { CreateReportDialog } from '@/components/CreateReportDialog';
import { useMyReportView } from '@/hooks/useMyReportView';

const SendReport = () => {
  const {
    paginatedPeriods,
    paginatedGroupPeriods,
    groupedReports,
    sortedReportGroups,
    currentPageReportCounts,
    totalReportCounts,
    activeTab,
    searchTerm,
    expandedRows,
    expandedPeriods,
    drawerIsOpen,
    refreshingReports,
    loading,
    authUserId,
    getUserInfo,
    formatDate,
    handleTabChange,
    handleDrawerToggle,
    handleDrawerClose,
    handleNextPage,
    handlePrevPage,
    handlePageChange,
    handleDeleteReport,
    handleAutoExpand,
    onSearchChange,
    toggleRowExpansion,
    togglePeriodExpansion,
    openFileUrl,
  } = useMyReportView();

  // Auto-expand first period when data loads
  useEffect(() => {
    handleAutoExpand();
  }, [handleAutoExpand]);

  if (loading && paginatedPeriods.totalPeriods === 0) {
    return (
      <div className="min-h-screen bg-background p-6">
        <div className="max-w-7xl mx-auto space-y-4">
          <Skeleton className="h-10 w-96" />
          <Skeleton className="h-64 w-full" />
        </div>
      </div>
    );
  }

  const sidebarProps = {
    reportGroups: sortedReportGroups,
    activeTab,
    currentPageReportCounts: totalReportCounts,
    isDrawerOpen: drawerIsOpen,
    onTabChange: handleTabChange,
    onDrawerClose: handleDrawerClose,
  };

  const listViewProps = {
    activeTab,
    searchTerm,
    expandedRows,
    expandedPeriods,
    refreshingReports,
    paginatedPeriods,
    paginatedGroupPeriods,
    groupedReports,
    onSearchChange,
    onToggleRowExpansion: toggleRowExpansion,
    onTogglePeriodExpansion: togglePeriodExpansion,
    onOpenFile: openFileUrl,
    onSummarizeReport: () => {},
    onDrawerToggle: handleDrawerToggle,
    onDeleteReport: handleDeleteReport,
    currentUserId: authUserId,
    getUserInfo,
    formatDate,
  };

  return (
    <div className="h-full bg-background flex flex-col overflow-hidden">
      <div className="max-w-7xl mx-auto w-full flex flex-1 min-h-0">
        <ReportGroupsSidebar {...sidebarProps} />
        <ReportListView {...listViewProps} />
      </div>

      <ReportFooter
        activeTab={activeTab}
        paginatedPeriods={paginatedPeriods}
        paginatedGroupPeriods={paginatedGroupPeriods}
        onNextPage={handleNextPage}
        onPrevPage={handlePrevPage}
        onPageChange={handlePageChange}
        isLoading={loading}
      />
    </div>
  );
};

export default SendReport;
